import { render, staticRenderFns } from "./supplierReduceCost.vue?vue&type=template&id=4289ac00"
import script from "./supplierReduceCost.vue?vue&type=script&lang=js"
export * from "./supplierReduceCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports